var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{ref:"heatmap",staticClass:"heatmap"}),(_vm.isBackground)?_c('div',{staticClass:"background background-img"}):_vm._e(),_c('div',{ref:"map",staticClass:"map",style:(_vm.mapStyles)})])}
var staticRenderFns = []

export { render, staticRenderFns }